import { render, staticRenderFns } from "./PurchasesSummary.vue?vue&type=template&id=49f11105"
import script from "./PurchasesSummary.vue?vue&type=script&lang=js"
export * from "./PurchasesSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports